import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';//相机
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer/ngx';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { WebResponesContext } from '../../model/common';
import {
  DownLoadFileOpenNativeParmas,
  SysScanQrParam,
  SysUploadFileParams,
  SysUploadFileFormDataParams,
  SysOpenFileParams,
  SysFieldsListParams,
  SysDownLoadAppParams,
  SysWriteFileParams,
  SysFileParams,
  SysImageFileParams
} from "src/model/sys.params";
import { MessageclientService } from "src/service/messageclient.service";
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { File } from '@ionic-native/file/ngx';
import { ImageResizer, ImageResizerOptions } from '@ionic-native/image-resizer/ngx';
import { FilePath } from '@ionic-native/file-path/ngx';
import { Sim } from '@ionic-native/sim/ngx';
import { Device } from '@ionic-native/device/ngx';
declare var app;
@Injectable({
  providedIn: 'root'
})
export class IndexService {

  /**
   * 硬件方法定义
   */
  constructor(
    private camera: Camera,
    private barcode: BarcodeScanner,
    private platform: Platform,
    private msg: MessageclientService,
    private fileOpener: FileOpener,
    private file: File,
    private imageResizer: ImageResizer,
    private filePath: FilePath,
    private sim: Sim,
    private device: Device
  ) {

  }

  /**
   * 拍照功能
   * @param option 参数对象，根据对应的平台传相应的参数
   * @-----native---对应参数
   * @param sourceType 拍照还是选择相册，0 相册；1 拍照；2 仅从设备的“相机胶卷”相册中选择图像
   * @param destinationType 定义拍照后的返回格式， 0(DATA_URL) Base64的字符串， 1(FILE_URI) 返回文件uri；为避免内存问题，建议使用1(FILE_URI);
   * @param quality 图像质量，范围为0 - 100；
   * @param saveToPhotoAlbum 拍照后保存到相册，true 保存，false 不保存；默认false
   * @param encodingType 返回的图片格式，0 返回JPEG编码的图像; 1 返回PNG编码的图像；默认JPEG
   * @param mediaType 拍照或者视频，0 照片，根据配置返回格式；1 视频，返回URL；2 两者都允许
   * @param allowEdit 选择照片前是否允许编辑 
   * @param targetWidth 缩放图像的宽度（像素）
   * @param targetHeight 缩放图像的高度（像素）
   * @-----WX-------对应参数
   * @param sourceType  可以指定来源是相册(album)还是相机(camera)，默认二者都有,default:['album','camera'];
   * @param sizeType 可以指定是原图(original)还是压缩图(compressed)，默认二者都有.default:['compressed'];
   * @param isSaveToAlbum 整型值，0表示拍照时不保存到系统相册，1表示自动保存，默认值是1
   * @param count 默认1，需要上传的图片个数,默认1
   */
  public getCameraPicture(option: CameraOptions): Promise<WebResponesContext> {
    const that = this;
    let webContext: WebResponesContext = new WebResponesContext();
    webContext.ResponseMessage.Success = false;
    webContext.ResponseMessage.ErrorMessage = "获取照片失败！";
    let options: CameraOptions = Object.assign({
      sourceType: that.camera.PictureSourceType.CAMERA,//拍照选择相机
      destinationType: that.camera.DestinationType.FILE_URI,
      encodingType: that.camera.EncodingType.JPEG,
      quality: 10,//图像质量，范围为0 - 100
      // targetWidth: 400,//缩放图像的宽度（像素）
      // targetHeight: 300,//缩放图像的高度（像素）
      mediaType: that.camera.MediaType.PICTURE,
      allowEdit: false,//选择图片前是否允许编辑
      // correctOrientation: true,//设置摄像机拍摄的图像是否为正确的方向
    }, option);
    return new Promise<WebResponesContext>((resolve, reject) => {
      that.camera.getPicture(options).then(fileUrl => {
        if (fileUrl) {
          if (options.destinationType == 1 || options.destinationType == 2) {
            that.UploadFile({ fileUrl: fileUrl, fileParam: { mimeType: "image/jpeg" } }).then(data=>{
              console.log(data,"UploadFile");
              resolve(data);
            }).catch(err=>{
              reject(err);
            });
          } else if (options.destinationType == 0) {
            let imageString = "data:image/jpeg;base64," + fileUrl;
            that.uploadFileFormData({ file: imageString }).then(data=>{
              console.log(data,"uploadFileFormData");
              resolve(data);
            }).catch(err=>{
              reject(err);
            });
          }
        } else {
          webContext.ResponseMessage.Success = false;
          reject(webContext);
        }
      }).catch(error => {
        webContext.ResponseMessage.Success = false;
        reject(webContext);
      });
    })
  }


  /**
   * 仅获取图片
   * @param option 
   */
  public getOnlyCameraPicture(option: CameraOptions): Promise<WebResponesContext> {
    const that = this;
    let webContext: WebResponesContext = new WebResponesContext();
    webContext.ResponseMessage.Success = false;
    webContext.ResponseMessage.ErrorMessage = "获取照片失败！";
    let options: CameraOptions = Object.assign({
      sourceType: that.camera.PictureSourceType.CAMERA,//拍照选择相机
      destinationType: that.camera.DestinationType.FILE_URI,
      encodingType: that.camera.EncodingType.JPEG,
      quality: 10,//图像质量，范围为0 - 100
      // targetWidth: 400,//缩放图像的宽度（像素）
      // targetHeight: 300,//缩放图像的高度（像素）
      mediaType: that.camera.MediaType.PICTURE,
      allowEdit: false,//选择图片前是否允许编辑
      // correctOrientation: true,//设置摄像机拍摄的图像是否为正确的方向
    }, option);
    return new Promise<WebResponesContext>((resolve, reject)=>{
      that.camera.getPicture(options).then(fileUrl => {
        if(fileUrl){
          webContext.ResponseMessage.Success = true;
          webContext.Status = fileUrl;
          resolve(webContext);
        }else{
          reject(webContext);  
        }
      }).catch(error=>{
        reject(webContext);
      })
    })
  }
  

  /**
   * 扫码二维码
   * @param desc 提示文字;微信和android可用
   * @param needResult 默认为0，扫描结果由企业微信处理，1 则直接返回扫描结果
   * @param scanType ["qrCode", "barCode"],微信可用 可以指定扫二维码还是条形码（一维码），默认二者都有
   * @param showTorchButton 是否显示手电筒；android和ios参数
   */
  public scanQRCode(option: SysScanQrParam): Promise<any> {
    const that = this;
    let webContext: WebResponesContext = new WebResponesContext();
    webContext.ResponseMessage.Success = false;
    webContext.ResponseMessage.ErrorMessage = "识别二维码失败！";
    return new Promise<WebResponesContext>((resolve, reject)=>{ 
      that.barcode.scan(option).then(data=>{
        if(data.text){
          webContext.ResponseMessage.Success = true;
          webContext.Status = data.text;
          resolve(webContext);
        }else if(data.cancelled){
          webContext.Status = "cancel";//取消事件
          reject(webContext);
        }else{
          reject(webContext);
        }
      }).catch(error=>{

        reject(webContext);
      });
    })
  }

  /**
   * 上传文件
   * @param fileUrl android和ios上传的文件路径,只能是路劲不能是base64位
   * @param fileParam android和ios上传需要传递的参数{"fileName":"xxxx"}.默认为{}
   * @param uploadUrl android和ios上传图片的服务器地址
   */
  public UploadFile(option: SysUploadFileParams): Promise<WebResponesContext> {
    const that = this;
    let webContext: WebResponesContext = new WebResponesContext();
    webContext.ResponseMessage.Success = false;
    webContext.ResponseMessage.ErrorMessage = "上传失败！";
    return new Promise<WebResponesContext>((resolve, reject) => {
      let transfer = new FileTransfer();
      const fileTransfer: FileTransferObject = transfer.create();
      let _option: FileUploadOptions = Object.assign({
        fileKey: 'file',
        fileName: that.GetImgFileName + ".jpg",
        // mimeType: "image/jpeg",
        httpMethod: "post",
        headers: null
      }, option.fileParam);
      let _uploadUrl = option.uploadUrl || app.UPLOADURL;
      let _msg = "已上传";
      that.msg.Loading(_msg).then(load => {
        fileTransfer.upload(option.fileUrl, _uploadUrl, _option).then(data => {
          load.dismiss();
          if (data.responseCode == 200) {
            let message = JSON.parse(data.response);
            webContext.ResponseMessage = message.ResponseMessage;
            if (message.ResponseMessage.Success && message.Status.length > 0) {
              webContext.Status = message.Status;
              resolve(webContext);
            } else {
              webContext.url = option.fileUrl;
              reject(webContext);
              
            }
          }
        }).catch(error => {
          load.dismiss();
          console.log(error);
          webContext.ResponseMessage.Success = false;
          webContext.url = option.fileUrl;
          // webContext.ResponseMessage.ErrorMessage = ;
          reject(webContext);
        });
        fileTransfer.onProgress((event: ProgressEvent) => {
          let num = Math.floor(event.loaded / event.total * 100);
          console.log(num, "百分比")
          if (num === 100) {
            load.message = '上传完成';
            load.dismiss();
          } else {
            let title = num;
            title && (load.message = _msg + num + '%');
          }
        });
        load.present();
      });
    });
  }

  /**
   * 字符串形式上传文件
   * option中的参数
   * @param file 文件字符串
   * @param fileName 文件名称
   * @param postType 上传类型，1异步，2同步;//异步上传只支持字符串
   */
  public uploadFileFormData(option: SysUploadFileFormDataParams): Promise<any> {
    const that = this;
    let url = app.UPLOADURL;//同步上传地址
    if (option.postType == 1) {//异步
      url = app.UPLOADURLSYNC;
    }
    return new Promise<any>((resolve, reject) => {
      let Msg = new WebResponesContext();
      Msg.ResponseMessage.Success = false;
      Msg.ResponseMessage.ErrorMessage = "上传失败，请稍后再试！";
      let FileName = option.fileName || (that.GetImgFileName + ".jpg");
      let formData = new FormData();
      formData.append('files', option.file, FileName);
      let obj: any = {};
      obj["FileName"] = FileName;
      formData.append('RequestBody', JSON.stringify(obj));
      try {
        var request = new XMLHttpRequest();
        // request.setRequestHeader("Content-Type","multipart/form-data; charset=UTF-8");
        request.open('post', url, true);
        // request.setRequestHeader('Authorization',"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoiU0EiLCJJRCI6ImIxYTAzYjMzLThjOGEtNDZjYS04MDRjLTE2NmJmNWIxNDY5YSIsIkRpc3BsYXlOYW1lIjoi6ZSA5ZSu5Luj6KGoIiwiTG9naW5OYW1lIjoiU0EiLCJBcHAiOiJ0cnVlIiwianRpIjoiYjFhMDNiMzMtOGM4YS00NmNhLTgwNGMtMTY2YmY1YjE0NjlhIiwiaWF0IjoiMjAxOS80LzE4IDI6NDU6MjMiLCJuYmYiOjE1NTU1NTU1MjMsImV4cCI6MTU1NTY0MTkyMywiaXNzIjoiaHR0cDovL3d3dy5tb2Jpem9uZS5jbiIsImF1ZCI6Ind3dy5tb2Jpem9uZS5jbiJ9.yGhPdG_90bdr8o8WDjneYdvQ6B4ysk_22Yxw8ZETHFg");
        request.send(formData);
        request.onreadystatechange = function (data) {
          console.log(data, "onreadystatechange");
          if (data.currentTarget["readyState"] == 4) {
            if (data.currentTarget['status'] == 200) {
              const body = JSON.parse(data.currentTarget['response']);
              if (body.ResponseMessage.Success) {
                Msg.ResponseMessage.Success = true;
                Msg.Status = body.Status;
              }
              resolve(Msg);
            } else {
              reject(Msg);
            }
          }
        }
      } catch (error) {
        reject(Msg);
      }
      if (option.postType == 1) {//表示异步,先返回结果
        let imgNameArr = app.UPLOADFileName + FileName;
        let Msg = new WebResponesContext();
        Msg.ResponseMessage.Success = true;
        Msg.ResponseMessage.ErrorMessage = "上传成功！";
        Msg.Status = new Array<any>();
        Msg.Status.push({ "FileName": imgNameArr })
        resolve(Msg);
      }
    });
  }

  /**
   * 下载文件并打开
   * @param option 参数对象
   * @-----native---对应参数
   * @param fileUrl 上传的文件url （硬件必填）
   * @param appFile 文件硬盘路径（硬件必填）
   * @param headers 头部文件（硬件必填）
   * @param target 文件mintype类型 （硬件必填）
   * @-----WX-------对应参数
   * @param url 上传的文件url （微信必填）
   * @param name  需要预览文件的文件名(不填的话取url的最后部分)
   * @param size 需要预览文件的字节大小 （微信必填）
   */
  DownLoadFileOpen(option: DownLoadFileOpenNativeParmas): void {
    const that = this;
    let transfer = new FileTransfer();
    const fileTransfer: FileTransferObject = transfer.create();
    that.msg.Loading("下载进度：0%").then((loads: HTMLIonLoadingElement) => {
      fileTransfer.download(option.fileUrl, option.appFile, true, option.headers).then((datas) => {
        console.log(datas, "下载完文件地址");
        that.fileOpener.open(datas.nativeURL, option.target)
          .then(success => {
            loads.dismiss();
            console.log(success);
          }, error => {
            loads.dismiss();
            console.log(error);
          })
          .catch(error => {
            loads.dismiss();
            that.msg.Alert(app.ERRORMESSAGE);
            console.log(error);
          });
      }).catch(error => {
        loads.dismiss();
        that.msg.Alert(app.ERRORMESSAGE);
      });
      console.log(loads);
      fileTransfer.onProgress((event: ProgressEvent) => {
        let num = Math.floor(event.loaded / event.total * 100);
        if (num === 100) {
          loads.message = '下载完成准备打开中,请稍后';
          loads.dismiss();
        } else {
          //console.log(loads);
          let title = num;
          title && (loads.message = '下载进度：' + num + '%');
        }
      });
      loads.present();
    });
  }

  /**
* 打开文件
* @param fileUrl 文件地址 https://xxxxxxxx.com.cn/xx.pdf
* @param target 文件类型,默认为"application/pdf";
*/
  public OpenFile(option: SysOpenFileParams) {
    // public OpenFile(fileUrl: string, target: string = "application/pdf") {
    let that = this;
    let transfer = new FileTransfer();
    const fileTransfer: FileTransferObject = transfer.create();
    //const apk = this.file.externalRootDirectory + 'android.apk'; //apk保存的目录
    let fileupload: any = option.fileUrl;
    let index: number = option.fileUrl.lastIndexOf("\/") + 1;
    let filesname = option.fileUrl.substring(index, option.fileUrl.length);//获取文件名称
    let appFileUri = that.file.cacheDirectory + filesname;
    let headers: any = {};
    headers["Content-type"] = "application/octet-stream";
    headers["Content-Disposition"] = "attachment;filename=" + filesname;
    let _errorOption: DownLoadFileOpenNativeParmas = {
      fileUrl: fileupload,
      appFile: appFileUri,
      headers: headers,
      target: option.target,
    }
    that.fileOpener.open(appFileUri, option.target)
      .then(success => {
        console.log(success, "文件打开成功");
      }, error => {
        that.DownLoadFileOpen(_errorOption);
        console.log(error, "文件打开失败");
      })
      .catch(error => {
        that.DownLoadFileOpen(_errorOption);
        console.log(error, "文件打开失败Error");
      });


  }

  /**
   * 根据目录获取文件
   * @param path 手机上真实的目录地址
   * @param dirName 文件或者目录名称
   */
  GetFieldsList(option: SysFieldsListParams): Promise<any> {
    // GetFieldsList(path: string = "", dirName: string = ""): Promise<any> {
    const that = this;
    return new Promise<any>((resolve, reject) => {
      //判断当前是否真机
      if (that.platform.is("cordova")) {
        option.path = that.file.tempDirectory;//默认ios临时目录
        if (that.platform.is("android")) {
          option.path = that.file.externalCacheDirectory;//android
        }
        that.file.listDir(option.path, option.dirName).then(data => {
          resolve(data);
          console.log(data);
        }).catch(err => {
          reject(err);
          console.log(err);
        });
      } else {
        reject("必须真机测试");
      }
    });
  }

  /**
   * 下载并安装App
   * @param Url app地址
   */
  public DownloadApp(option: SysDownLoadAppParams): void {
    // public DownloadApp(Url: string): void {
    let that = this;
    that.msg.Loading("下载进度：0%").then((loads: HTMLIonLoadingElement) => {
      let transfer = new FileTransfer();
      const fileTransfer: FileTransferObject = transfer.create();
      //const apk = this.file.externalRootDirectory + 'android.apk'; //apk保存的目录
      let apk = that.file.externalDataDirectory + 'android.apk';
      let fileupload: any = "";
      if (option.Url) {
        fileupload = option.Url;
      } else {
        if (!app.RELEASE) {//测试地址
          apk = that.file.externalDataDirectory + 'androidtest.apk';
          fileupload = app.DOWNLOAD_ANDROID_URL_TEST;
        } else {
          fileupload = app.DOWNLOAD_ANDROID_URL;
        }
      }
      fileTransfer.download(fileupload, apk).then((datas) => {
        that.fileOpener.open(apk, "application/vnd.android.package-archive")
          .then(success => {
            loads.dismiss();
            console.log(success);
          }, error => {
            loads.dismiss();
            console.log(error);
          })
          .catch(error => {
            loads.dismiss();
            that.msg.Alert("目前网络繁忙，请稍后再试");
            console.log(error);
          });
      }).catch(error => {
        loads.dismiss();
        that.msg.Alert("目前网络繁忙，请稍后再试");
      });
      console.log(loads);
      fileTransfer.onProgress((event: ProgressEvent) => {
        let num = Math.floor(event.loaded / event.total * 100);
        if (num === 100) {
          loads.message = '下载完成准备安装,请稍后';
          loads.dismiss();
        } else {
          console.log(loads);
          let title = num;
          title && (loads.message = '下载进度：' + num + '%');
        }
      });
      loads.present();
    });
  }

  /**
* 保存文件到手机临时目录,默认保存在 externalCacheDirectory目录
* @param stringContent 需要保存的数据对象，必须是string类型数据，否则保存失败
* @param fileName 需要保存的文件名称以及类型,默认"a2.json"
*/
  WriteFile(option: SysWriteFileParams): Promise<any> {
    // WriteFile(stringContent: any, fileName: any = "a2.json"): Promise<any> {
    const that = this;
    return new Promise<any>((resolve, reject) => {
      //判断当前是否真机
      if (that.platform.is("cordova")) {
        let tempDirectory: any = that.file.tempDirectory;//默认ios临时目录
        console.log(tempDirectory);
        if (that.platform.is("android")) {
          tempDirectory = that.file.externalCacheDirectory;//android
        }
        try {
          console.log("保存文件之前", "单文件");
          that.file.writeFile(tempDirectory, option.fileName, option.stringContent, { replace: true }).then(data => {
            console.log(data);
            resolve(data);
          }).catch(err => {
            console.log(err);
            reject(err);
          });
        } catch (err) {
          reject(err);
        }
      } else {
        reject("非真机环境");
      }
    });
  }

  /**
   * 保存文件到手机临时目录,如果文件存在则合并数据；默认保存在 externalCacheDirectory目录
   * @param stringContent 需要保存的数据对象，必须是string类型数据，否则保存失败
   * @param fileName 需要保存的文件名称以及类型,默认"a2.json"
   */
  WriteMergeFile(option: SysWriteFileParams): Promise<any> {
    const that = this;
    return new Promise<any>((resolve, reject) => {
      //判断当前是否真机
      if (that.platform.is("cordova")) {
        let tempDirectory: any = that.file.tempDirectory;//默认ios临时目录
        if (that.platform.is("android")) {
          tempDirectory = that.file.externalCacheDirectory;//android
        }
        try {
          console.log("保存文件之前", "多文件");
          that.file.readAsText(tempDirectory, option.fileName).then(fileData => {//P判断当前文件是否存在,并判断时候有值
            let tempobj: Array<any> = new Array<any>();
            let arrayobj: any = JSON.parse(fileData);
            if (arrayobj.constructor == Array) {
              tempobj = arrayobj;
            } else {
              tempobj.push(arrayobj);
            }
            let temp = JSON.parse(option.stringContent);
            tempobj.push(temp);
            that.WriteFile({ stringContent: JSON.stringify(tempobj), fileName: option.fileName }).then(data => {
              console.log(data);
              resolve(data);
            }).catch(err => {
              console.log(err);
              reject(err);
            });
          }).catch(err => {
            that.WriteFile({ stringContent: option.stringContent, fileName: option.fileName }).then(data => {
              console.log(data);
              resolve(data);
            }).catch(err => {
              console.log(err);
              reject(err);
            });
          });
        } catch (err) {
          reject(err);
        }
      } else {
        reject({ "error": "非真机环境" });
      }
    });
  }

  /**
   * 删除文件
   * @param fileUrl 文件本地地址
   * @param fileName 文件名称
   */
  public DeleteFile(option: SysFileParams): Promise<any> {
    const that = this;
    return new Promise<any>((resolve, reject) => {
      that.file.removeFile(option.fileUrl, option.fileName).then(data => {
        resolve(true);
      }).catch(err => {
        reject(false);
      });
    })
  }

  /**
   * 获取图片大小
   * @param fileUrl 图片地址
   */
  public getImgSize(option: SysImageFileParams): Promise<number> {
    const that = this;
    return new Promise<any>((resolve, reject) => {
      that.file.resolveLocalFilesystemUrl(option.fileUrl).then(fileEntry => {
        console.log("resolveLocalFilesystemUrl", JSON.stringify(fileEntry));
        fileEntry.getMetadata(file => {
          console.log(file.size);
          if (file.size) {
            resolve(file.size);
          } else {
            reject("未获取到图片大小!");
          }
        }, err => {
          reject("未获取到图片大小!");
          console.log(err);
        })
      }).catch(err => {
        reject("未获取到图片大小!");
      })
    })
  }

  /**
   * 图片压缩
   * @param fileUrl 文件本地路径
   * @param fileName 文件名称// ios下必传
   */
  imgResize(option: SysFileParams): Promise<any> {
    const that = this;
    let options = {
      uri: option.fileUrl,
      folderName: 'iSmart',
      quality: 50,
      width: 1280,
      height: 1280
    } as ImageResizerOptions;
    if (that.platform.is("ios")) {
      options["fileName"] = option.fileName;
    }
    return new Promise<any>((resolve, reject) => {
      that.imageResizer
        .resize(options)
        .then((filePath2: string) => {
          console.log('FilePath', filePath2);
          resolve(filePath2);
        }).catch(e => {
          reject("图片压缩失败!");
        });
    })
  }

  /**
   * 获取安卓文件真实地址
   * @param fileUrl 相册选择图片获取到的地址
   */
  public getNativePath(option: SysImageFileParams): Promise<any> {
    const that = this;
    return new Promise<any>((resolve, reject) => {
      that.filePath.resolveNativePath(option.fileUrl).then(realFilePath => {
        if (realFilePath) {
          resolve(realFilePath);
        } else {
          reject("获取地址失败！");
        }
      }).catch(error => {
        reject("获取地址失败！");
      })
    })
  }

  /**
   * 获取sim信息
   */
  get PhoneNumber(): Promise<any> {
    const that = this;
    return new Promise<any>((resolve, reject) => {
      if (that.platform.is('cordova')) {
        that.sim.getSimInfo().then(data => {
          resolve(data);
        }).catch(error => {
          reject(error);
        });
      } else {
        resolve("");
      }
    });
  }

  /**
 * 同步日志
 */
  LogSyn() {
    const that = this;
    if (that.platform.is("cordova")) {
      let _option: SysFieldsListParams = {
        path: that.file.tempDirectory
      }
      that.GetFieldsList(_option).then(data => {
        // that.msg.Show("日志同步成功");
        console.log(data, "日志");
        if (data.length > 0) {
          data.forEach(fied => {
            if (fied.isFile) {
              let index: number = fied.name.lastIndexOf(".") + 1;
              let filesname = fied.name.substring(index, fied.name.length);//获取文件名称类型
              if (filesname == "txt") {//获取过滤txt文件
                let parms = {};
                let account = JSON.parse(localStorage.getItem("account"));
                parms["storeId"] = null;
                parms["TBProductBrand_ID"] = account.Id || null;//类型ID
                let filesType: any = account.LoginName || null;
                if (!filesType) { filesType = "login"; }
                parms["SavePath"] = "uploads/AppError/" + filesType;//分类类型
                let _option: SysUploadFileParams = {
                  fileUrl: fied.nativeURL,
                  fileParam: parms
                }
                that.UploadFile(_option).then(result => {
                  let fileIdex: number = fied.name.lastIndexOf("/") + 1;
                  let fileName: any = fied.name.substring(fileIdex, fied.name.length);//获取文件名称
                  let fileUrl: any = fied.nativeURL.substring(0, fied.nativeURL.lastIndexOf("/"));
                  that.file.removeFile(fileUrl, fileName).then(data => {
                    console.log(data, "日志删除成功");
                  }).catch(err => {
                    console.log(err, "日志删除失败");
                  });
                }).catch(err => {
                  // that.msg.Show("暂无日志");
                });
              }
            }
          });
        } else {
          // that.msg.Show("暂无日志");
        }
      }).catch(err => {
        console.log(err);
      });
    }
  }

  /**
 * 日志删除
 */
  DeleteLog() {
    const that = this;
    if (that.platform.is("cordova")) {
      let _option: SysFieldsListParams = {
        path: that.file.tempDirectory
      }
      that.GetFieldsList(_option).then(data => {
        console.log(data, "日志");
        if (data.length > 0) {
          data.forEach(fied => {
            if (fied.isFile) {
              let index: number = fied.name.lastIndexOf(".") + 1;
              let filesname = fied.name.substring(index, fied.name.length);//获取文件名称
              if (filesname == "txt") {//获取过滤txt文件
                that.file.removeFile(fied.nativeURL, filesname).then(data => {
                  console.log(data, "日志删除成功");
                }).catch(err => {
                  console.log(err, "日志删除失败");
                });
              }
            }
          });
        } else {
          // that.msg.Show("暂无日志");
        }
      }).catch(err => {
        console.log(err);
      });
    }

  }

  /**
   * 获取android 手机上唯一识别码；只能适用于android
   */
  GetIMEI() {
    const that = this;
    return new Promise<any>((resolve, reject) => {
      that.file.readAsText(that.file.externalRootDirectory, ".imei").then(data => {
        resolve(data);
      }).catch(err => {
        that.file.writeFile(that.file.externalRootDirectory, ".imei", that.device.uuid, { replace: true }).then(data => {
          resolve(that.device.uuid);
        }).catch(err => {
          reject(err);
        });
      });
    });

  }

  /**
   * 退出程序
   */
  public exitApp(): void {
    let that = this;
    that.msg.Confirm("确定退出应用程序？").then(data => {
      if (data) {
        navigator['app'].exitApp();
      }
    });
  }

  /**
 * 获取上传图片名称
 * 默认为当前时间戳
 */
  get GetImgFileName(): string {
    let date: Date = new Date();
    let year, month, day;
    let riqi = date.getFullYear().toString().substring(2, 4);
    let tmp1: any = date.getMonth() + 1;
    let tmp2: any = date.getDate();
    month = tmp1;
    day = tmp2;
    if (tmp1 < 10) {
      month = "0" + tmp1;
    }
    if (tmp2 < 10) {
      day = "0" + tmp2;
    }
    year = riqi;
    return year + month + day + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds();
  }
}